Schedule:
<mat-form-field class="no-subscript">
  <mat-select
    [disabled]="disabled"
    [(value)]="scheduleType"
    (selectionChange)="scheduleTypeSelected()"
  >
    <mat-option
      *ngFor="let type of scheduleTypes"
      [value]="type"
      [displayWith]="displayType"
    >
      {{ type.acronym }}
    </mat-option>
  </mat-select>
</mat-form-field>
<div *ngIf="showLocation">
  Location:
  <mat-form-field>
    <mat-select
      [disabled]="disabled"
      [(value)]="scheduleData"
      (selectionChange)="locationSelected()"
    >
      <mat-option
        *ngFor="let sr of scheduleDatas"
        [value]="sr"
        [displayWith]="displayLocation"
      >
        {{ sr.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
